import { render, staticRenderFns } from "./BucketListItems.vue?vue&type=template&id=33902ac6&"
import script from "./BucketListItems.vue?vue&type=script&lang=js&"
export * from "./BucketListItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports